import { createContext, useContext } from 'react';
import { Playlist } from '@raydiant/api-client-js';

type ShouldHidePlaylist = (playlist?: Playlist | null) => boolean;

const ScheduleVisibilityContext = createContext<ShouldHidePlaylist>(
  () => false,
);

export const useScheduleVisibility = () =>
  useContext(ScheduleVisibilityContext);

export default ScheduleVisibilityContext;
